export const PDF_PLACEHOLDER_HTML = `<!doctype html>
<html lang="en"><head><meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>Generating statement...</title>
<style>
  :root { color-scheme: light; }
  body { margin: 0; min-height: 100vh; display: flex; align-items: center; justify-content: center;
         background: #f7f8fb; color: #0f172a;
         font-family: "DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
  .box { text-align: center; padding: 24px; }
  .ring { width: 44px; height: 44px; margin: 0 auto 20px; border-radius: 50%;
          border: 4px solid #e6f1ff; border-top-color: #0089ff;
          animation: spin 900ms linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
  h1 { font-size: 17px; font-weight: 600; margin: 0 0 6px; letter-spacing: -0.01em; }
  p { font-size: 14px; color: #64748b; margin: 0; }
  #statement-for { display: block; font-size: 14px; color: #005fb8; margin-top: 12px; }
  @media (prefers-reduced-motion: reduce) { .ring { animation: none; } }
</style></head>
<body>
  <div class="box" role="status" aria-live="polite">
    <div class="ring" aria-hidden="true"></div>
    <h1 id="pdf-title">Generating PDF</h1>
    <p id="pdf-detail">This can take 10-15 seconds.</p>
    <span id="statement-for"></span>
  </div>
</body></html>`;

export function writePdfPlaceholder(win, customerName, labels) {
  const doc = win?.document;
  if (!doc || typeof doc.write !== 'function') return false;
  try {
    doc.open();
    doc.write(PDF_PLACEHOLDER_HTML);
    doc.close();
    if (labels) {
      if (labels.title) doc.title = labels.title;
      const heading = doc.getElementById('pdf-title');
      if (heading && labels.heading) heading.textContent = labels.heading;
      const detail = doc.getElementById('pdf-detail');
      if (detail && labels.detail) detail.textContent = labels.detail;
    }
    const who = doc.getElementById('statement-for');
    if (who && customerName) who.textContent = customerName;
    return true;
  } catch {
    return false;
  }
}

export function createObjectUrlRegistry(urlApi = URL) {
  const urls = [];
  return {
    create(blob) {
      const url = urlApi.createObjectURL(blob);
      urls.push(url);
      return url;
    },
    revokeAll() {
      urls.forEach((url) => urlApi.revokeObjectURL(url));
      urls.length = 0;
    },
  };
}

export function downloadBlob(blob, filename, { doc = document, urlApi = URL } = {}) {
  let url = null;
  let link = null;
  try {
    url = urlApi.createObjectURL(blob);
    link = doc.createElement('a');
    link.href = url;
    link.download = filename;
    doc.body.appendChild(link);
    link.click();
  } finally {
    link?.remove();
    if (url) urlApi.revokeObjectURL(url);
  }
}
